import { BASE_URL, CARD_URL, ACR, HOME} from "../../constant/urls";
import axios from "axios";

export const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}
/** Search */
export const requestSearch = (event, setSearch, tabledataCopy, setTabledata) => {
  let searchedVal = event?.target?.value;
  setSearch(searchedVal);
  const filteredRows = tabledataCopy.filter((row) => {
    return (row.exch_sau.toLowerCase().includes(searchedVal.toLowerCase()) || row.exchange.toLowerCase().includes(searchedVal.toLowerCase()));
  });
  setTabledata(filteredRows);
};

export const handlecolor = (row, exchsau) => {
  if (row.exchange === exchsau) {
    return "rgb(222, 184, 135)"
  }
  else {
    return null
  }
}

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export const handleChangeRowsPerPage = (event,setRowsPerPage,setPage) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  export const getHomeDetails = (ouc,selectedSolution,excludeEODP,resetAdmin,accounts,setOpen,setLoading,setPage,setCardList,setSnackMsg,setAlertOpen,search,setTabledata,setTabledataCopy,exchsau,setSearch) => {
 
  let params = {
    select_region: ouc["ouc"],
    exclude_solution: selectedSolution.toString(),
    exclude_eodps:
      excludeEODP.toString().charAt(0).toUpperCase() + excludeEODP.toString().slice(1),
    logged_user: accounts[0]?.idTokenClaims.EIN,
    resetAdmin: resetAdmin.toString().charAt(0).toUpperCase() + resetAdmin.toString().slice(1)
  };

    axios
      .get(`${BASE_URL}/${ACR}${CARD_URL}`, { params: params })
      .then((response) => {
        setOpen(true);
        setLoading(true);
        setPage(0);
        setCardList(response?.data?.results);
        setLoading(false);
        setOpen(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        setOpen(false);
        setSnackMsg("Something went wrong!.Please try again!");
        setAlertOpen(true);
      });

    axios
      .get(`${BASE_URL}/${ACR}${HOME}`, { params: params })
      .then((tableResponse) => {
        setOpen(true);
        setLoading(true);
        const tabledata = tableResponse?.data?.results || [];
        search === "" && setTabledata(tabledata);
        search === "" && setTabledataCopy(tabledata);
        // if (search === "") {
        //   setTabledata(tabledata);
        //   setTabledataCopy(tabledata);
        // }
        if (exchsau) {
          setSearch(exchsau);
          const filteredRows = tabledata.filter((row) => {
            return (
              row.exch_sau.toLowerCase().includes(exchsau.toLowerCase()) ||
              row.exchange.toLowerCase().includes(exchsau.toLowerCase())
            );
          });
          setTabledata(filteredRows);
        }
        setLoading(false);
        setOpen(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        setOpen(false);
        setSnackMsg("Something went wrong!.Please try again!");
        setAlertOpen(true);
      });
  };
// eslint-disable-next-line import/no-anonymous-default-export
export default { descendingComparator, requestSearch,getComparator }